"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editGoodsPageConfig = editGoodsPageConfig;
exports.getGoodsPageConfig = getGoodsPageConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
function getGoodsPageConfig(params) {
  return (0, _request.default)({
    url: '/portal/system/custom/goods/getGoodsPageConfig',
    method: 'get',
    params: params
  });
}
function editGoodsPageConfig(data) {
  return (0, _request.default)({
    url: '/portal/system/custom/goods/editGoodsPageConfig',
    method: 'post',
    data: data
  });
}